import { DecimalPipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { standardCarmMoneyFormat } from '@carm/_utils/utility-functions';

@Pipe({ name: 'carmMoneyPipe'})
export class MoneyPipe implements PipeTransform  {
  constructor(public decimalPipe: DecimalPipe, @Inject(LOCALE_ID) private localId) {

  }
  transform(value: number, symbol?: string) {
    return standardCarmMoneyFormat(this.decimalPipe, value, symbol, this.localId);
  }
}
